import React, {useState} from "react";
import Slider from "react-slick";
import PropTypes from "prop-types";
import styles from "./styles.css";
import ImageSliderModal from "../image-slider-modal/component";
import { yieldToMain } from "../../../utils/helpers/yield-to-main";
import { fastlyUrl } from "../../../utils/helpers/cdn-image-url";
const PremiumFeatureRevamp = ({content, config}) => {
    const {premium: premiumImages = [], premiumWithIcons = []} = content?.features || {};
    const [showFeatureModal, setShowFeatureModal] = useState(false);
    const [currentSlide, setCurrentSlide] = useState(0);
    const onSliderScroll = () => {
    };
    const settings = {
        slidesToShow: 2.9,
        slidesToScroll: 1,
        arrow: true,
        dots: false,
        infinite: false,
        afterChange: onSliderScroll

    };
    const showModalHandler = async(index) => {
        if (index) {
            setCurrentSlide(index);
        } else {
            setCurrentSlide(0);
        }
        setShowFeatureModal(!showFeatureModal);
        await yieldToMain();
    };

    return (
        <React.Fragment>
            <div styleName={"styles.outer"}>
                <p styleName={"styles.premiumFeatureheading"}>Premium Features</p>
                <div styleName="styles.featureTextContainer">
                    {(premiumWithIcons || []).map(item => {
                        const {icon} = item;
                        return (
                            <p key={item} styleName={"styles.slideDetail"}><img src={fastlyUrl(config?.brandImageHost, icon)} />{item?.label}</p>
                        );
                    })}
                </div>
                <div styleName={"styles.rightWrapper"}>
                    <Slider {...settings}>
                        {(premiumImages || []).map((item, index) => {
                            const {image, featureName} = item;
                            return (
                                <div key={featureName} styleName={"styles.slidesOuter"} >
                                    <div styleName={"styles.imageWrapper"}>
                                        <img src={fastlyUrl(config?.imageHost, image, "premiumFeatures")} onClick={() => showModalHandler(index)}/>
                                        {/* <p>{featureName}</p> */}
                                    </div>
                                </div>
                            );
                        })}
                    </Slider>
                </div>
            </div>
            {showFeatureModal && <ImageSliderModal onClose={showModalHandler} images={premiumImages} config={config} selectedSlide={currentSlide} />}

        </React.Fragment>
    );
};

PremiumFeatureRevamp.propTypes = {
    content: PropTypes.object,
    config: PropTypes.object
};
export default PremiumFeatureRevamp;
